<template>
  <div v-if="theme" class="o-newsletter">
    <div class="c-newsletter-container" :class="themeClass" :style="componentStyling">
      <div class="c-newsletter">
        <h3 class="c-newsletter__title">{{ theme.title }}</h3>
        <p v-if="hasSubmitted" class="c-newsletter__success">{{ theme.success }}</p>
        <p v-else-if="hasError" class="c-newsletter__error">
          Er ging iets mis probeer later opnieuw
        </p>
        <div v-else class="c-newsletter__body">
          <div class="c-newsletter__form">
            <input type="text" placeholder="E-mailadres" v-model="email" />
            <button class="c-newsletter__button c-button" @click="submitForm" :disabled="isSending">
              {{ theme.buttonText }}
            </button>
          </div>
          <p class="c-newsletter__text">
            {{ theme.body }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import settings from "@config/site.yml?path=site.{rails_env}.public.newsletterOptIn"

export default {
  name: "App",
  data() {
    return {
      email: "",
      isSending: false,
      hasSubmitted: false,
      hasError: false,
      theme: null,
    }
  },
  computed: {
    componentStyling() {
      return {
        "--button-color": this.theme.buttonColor
      }
    },
    themeClass() {
      return `c-newsletter-container--${this.theme.theme}`
    }
  },
  async mounted() {
    await this.selectRandomTheme()
  },
  methods: {
    async submitForm() {
      if (this.isSending || !this.email) {
        return
      }

      this.isSending = true

      try {
        await axios.post(`/webform/forms/${settings.formId}/submissions.js`, {
          webform_submission: {
            answers_attributes: {
              0: { webform_question_id: settings.webformAnswerIds.email, content: this.email },
              1: {
                webform_question_id: settings.webformAnswerIds.path,
                content: window.location.pathname
              },
              2: {
                webform_question_id: settings.webformAnswerIds.theme,
                content: this.theme.uniqueName
              }
            }
          }
        })

        this.hasSubmitted = true
      } catch {
        this.hasError = true
      } finally {
        this.isSending = false
      }
    },
    async getThemes() {
      if (!settings.airtableUrl) {
        return []
      }

      // Service worker hosted on Cloudflare to get items from the airtable: https://airtable.com/appl5Bn27hf8rLt7P
      const response = (await axios.get(settings.airtableUrl)).data

      return response?.map(({ fields }) => fields) ?? []
    },
    async selectRandomTheme() {
      const themes = await this.getThemes()
      let randomNumber = Math.random()

      for (let i = 0; i < themes.length; i++) {
        if (randomNumber <= themes[i].percentage) {
          this.theme = themes[i]
          break
        }

        randomNumber -= themes[i].percentage
      }
    }
  }
}
</script>
